import React from 'react';
import ActionButtons from './actionbuttons';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import styles from './expandablesection_styles';

const ExpandableSection = (props) => {
  const {
    controller,
    handleCancel,
    handleSave,
    isOpened,
    isChanged,
    isLoading,
    cancelTitle,
    saveTitle,
    handlePreview,
    handleDownload,
    isDownloading,
    isProcessing,
    processingTitle,
    disableSave,
    disableCancel,
    hideFooter
  } = props;

  return (
    <div className={`expandablesection ${props.classes.expandablesection} ${props.className}`}>
      {controller}
      <div className={classNames({
        collapsable: true,
        opened: isOpened,
      })}>
        <div className='innerWrap'>
          {props.children}
        </div>
      </div>
      {isOpened && !hideFooter &&
      <div className='footer controls'>
        <ActionButtons
          handlePreview={handlePreview}
          handleCancel={handleCancel}
          handleSave={handleSave}
          isChanged={isChanged}
          isLoading={isLoading}
          cancelTitle={cancelTitle}
          saveTitle={saveTitle}
          handleDownload={handleDownload}
          isDownloading={isDownloading}
          isProcessing={isProcessing}
          processingTitle={processingTitle}
          disableSave={disableSave}
          disableCancel={disableCancel}
        />
      </div>
      }
    </div>
  )
};

export default injectSheet(styles)(ExpandableSection)
